import { getLanguageCode } from './utilities';

class SearchOverlay
{
    constructor()
    {
        // Elements
        this.body = document.querySelector('body');
        this.categoriesContainer = document.querySelector('.js-pso__category--container');
        this.searchtermsContainer = document.querySelector('.js-pso__searchterm--container');
        this.categoriesHistory = document.querySelector('.js-pso__category--history');
        this.searchtermsHistory = document.querySelector('.js-pso__searchterm--history');
        this.searchtermTemplate = document.querySelector('.js-pso__searchterm--template');
        this.removeHistoryButton = document.querySelector('.js-pso__history--remove');

        // Helpers
        this.historyKey = 'searchOverlayHistory';
    }

    init()
    {
        if (this.body.id === 'category')
        {
            this.saveToLocalStorage();
        }

        this.readFromLocalStorage();

        this.initEvents();
    }

    saveToLocalStorage()
    {
        const userSearchTerm = document.querySelector('meta[name="userSearchTerm"]').content;
        const currentCategory = document.querySelector('meta[name="currentCategory"]').content;

        let history = JSON.parse(localStorage.getItem(this.historyKey)) || { searchTerms: [], categories: [] };

        if (userSearchTerm !== '')
        {
            history.searchTerms = this.updateHistory(
                history.searchTerms,
                userSearchTerm,
                10
            );
        }

        if (currentCategory !== '00.00.00.00')
        {
            history.categories = this.updateHistory(
                history.categories,
                currentCategory,
                3
            );
        }

        localStorage.setItem(this.historyKey, JSON.stringify(history));
    }

    updateHistory(history, newEntry, limit)
    {
        history = history.filter(oldEntry => oldEntry !== newEntry);

        history.push(newEntry);

        if (history.length > limit)
        {
            history = history.slice(history.length - limit);
        }
        return history;
    }

    readFromLocalStorage()
    {
        const history = JSON.parse(localStorage.getItem(this.historyKey));

        if (!history) return;

        if (history.searchTerms.length)
        {
            this.handleSearchTerms(history.searchTerms, history);

            this.searchtermsContainer.classList.remove('hidden');
        }

        if (history.categories.length)
        {
            this.fetchCategoryTags(history.categories)
                .then(response => response.json())
                .then(categories =>
                {
                    this.handleCategories(categories);

                    this.categoriesContainer.classList.remove('hidden');
                });
        }

        if (history.searchTerms.length || history.categories.length)
        {
            this.removeHistoryButton.classList.remove('hidden');
        }
    }

    handleSearchTerms(searchTerms, history)
    {
        searchTerms.forEach(searchTerm =>
        {
            const searchtermElement = this.searchtermTemplate.cloneNode(true);

            searchtermElement.classList.remove('hidden');

            searchtermElement.querySelector('.js-pso__searchterm--link').innerText = searchTerm;
            searchtermElement.querySelector('.js-pso__searchterm--link').href += searchTerm;

            searchtermElement.querySelector('.js-pso__searchterm--remove').addEventListener('click', event =>
            {
                event.preventDefault();

                searchtermElement.remove();

                history.searchTerms = history.searchTerms.filter(entry => entry !== searchTerm);

                if (!history.searchTerms.length)
                {
                    this.searchtermsContainer.classList.add('hidden');

                    if (!history.categories.length)
                    {
                        this.removeHistoryButton.classList.add('hidden');
                    }
                }

                localStorage.setItem(this.historyKey, JSON.stringify(history));
            });

            this.searchtermsHistory.append(searchtermElement);
        });
    }

    fetchCategoryTags(categories)
    {
        return fetch(
            '/api-category-snippets-' + getLanguageCode()
            + '?categories=' + categories.join(',') + '&snippet=snippets/category-tag'
        );
    }

    handleCategories(categories)
    {
        const template = document.createElement('template');

        Object.entries(categories).forEach(([, snippet]) =>
        {
            template.innerHTML = snippet.trim();

            this.categoriesHistory.append(template.content);
        });
    }

    initEvents()
    {
        this.removeHistoryButton.addEventListener('click', () =>
        {
            this.categoriesHistory.innerHTML = '';
            this.searchtermsHistory.innerHTML = '';

            this.categoriesContainer.classList.add('hidden');
            this.searchtermsContainer.classList.add('hidden');
            this.removeHistoryButton.classList.add('hidden');

            localStorage.removeItem(this.historyKey);
        });
    }
}

const searchOverlay = new SearchOverlay();

searchOverlay.init();
